export const LocalStorageConstants = {
  OKTA_TOKEN: "okta-token-storage",
  FEEDBACK_SURVEY_FILTERS: {
    SURVEY_TYPE: "feedback-survey-filters-survey-type",
    STATUS_TYPE: "feedback-survey-filters-status-type",
    CLUB: "feedback-survey-filters-club",
    ORG: "feedback-survey-filters-org",
    LEVEL: "feedback-survey-filters-level",
    LEAGUE: "feedback-survey-filters-league",
    REVIEWED: "feedback-survey-filters-reviewed",
    COMMENTS: "feedback-survey-filters-comments",
    MEDIA: "feedback-survey-filters-media",
    FLAGS: "feedback-survey-filters-flags",
    HIDE_GROUPING: "feedback-survey-filters-hide-grouping",
    OPEN: "feedback-survey-filters-open",
    SEARCH: "feedback-survey-filters-search",
    DATE_RANGE: "feedback-survey-filters-date-range",
    DATE_RANGE_IS_CUSTOM: "feedback-survey-filters-date-range-is-custom",
  },
};
